import React, { useContext, useEffect, useRef, useState } from 'react';
import { PromisedDonerHistoryContext } from '../PromisedDonerComponent';
import DateFormat from '../../../Utilities/DateFormat';
import NumberSeparator from '../../../Utilities/NumberSeparator';
import { Button, Table } from 'react-bootstrap';
import TableTwoBody from '../../CommonComponent/BootstrapTable2Body/TableTwoBody';
import { useDispatch } from 'react-redux';
import { promisedToCollectionAction } from '../../../Redux/Action/AgentAction';
import { SiCashapp } from "react-icons/si";
import { FiEdit } from '@react-icons/all-files/fi/FiEdit';
import { MdDeleteForever } from "react-icons/md";
import { FaPrint } from 'react-icons/fa6';
import { useNavigate } from 'react-router-dom';


function PromisedHistorytable(props) {
    const dispatch = useDispatch()
    const btnRef = useRef()
    const navigate = useNavigate()



    // Context
    const {
        filteredPromisedCollectionHistory,
        setPromisedDonerHistory,
        promisedToCollectionModelShow,
        setPromisedToCollectionModelShow,
        promisedToCollectionSingle,
        setPromisedToCollectionSingle,
        promisedReload,
        setPromisedReload,
        setPromiseEditModal,
        setPromiseDeleteModal
    } = useContext(PromisedDonerHistoryContext)
    // states
    const [totalWalletAmount, setTotalWalletAmount] = useState(0)


    // making total wallet amount
    useEffect(() => {
        // console.log(agentWalletHistory)
        let totalWallet = 0
        filteredPromisedCollectionHistory.map(singleWallet => {
            totalWallet += singleWallet.collection_amount
        })
        setTotalWalletAmount(totalWallet)
    }, [filteredPromisedCollectionHistory])



    const columns = [{
        dataField: 'id',
        text: 'SL',
        sort: true,
        headerStyle: (colum, colIndex) => {
            return {
                width: '50px',
            };
        },
        formatter: (cell, row, rowIndex) => {
            return <>
                {rowIndex + 1}
            </>
        }
    }, {
        dataField: 'member.member_name',
        text: 'Donor Name',
        sort: true


    }, {
        dataField: 'member.phone',
        text: 'Phone',
        sort: true,
        formatter: (cell, row, rowIndex) => {
            return <>
                {row?.member?.mobile || "N/A"}
            </>
        }


    }, {
        dataField: 'member.village',
        text: 'Village',
        sort: false,



    }, {
        dataField: 'member.police_station',
        text: 'Police Station',
        sort: false,



    }, {
        dataField: 'cnfg_organization.organization_name',
        text: 'Organization ',
        sort: true,


    }, {
        dataField: 'purpose',
        text: 'Purpose ',
        sort: true,
        formatter: (cell, row, rowIndex) => {
            return <>
                {cell == "Other" ? row.goods : cell}
            </>
        }

    }, {
        dataField: '',
        text: 'Promised By',
        sort: false,
        formatter: (cell, row, rowIndex) => {
            return <>
                {`${row.user?.full_name}, I'D ${row.user?.id}`}
            </>
        }
    }, {
        dataField: 'createdAt',
        text: 'Date',
        sort: false,
        formatter: (cell, row, rowIndex) => {
            return <>
                {DateFormat.format(cell)}
            </>
        }
    }, {
        dataField: 'collection_amount',
        text: 'Amount',
        sort: false,
        headerAlign: 'right',   // header right
        align: 'right',
        formatter: (cell, row, rowIndex) => {
            return <>
                {NumberSeparator.format(cell)}
            </>
        }
    }, {
        dataField: '',
        text: 'Action',
        headerClasses: 'mobile-action-promised',
        sort: false,
        headerStyle: (colum, colIndex) => {
            return {
                textAlign: "center"

            };
        },
        formatter: (cell, row, rowIndex) => {
            return <>
                {/* <Button onClick={(e) => {
                    setPromisedToCollectionSingle(row)
                    setPromisedToCollectionModelShow(true)
                }

                }>Promised to Collection</Button > */}
                {/* collection  */}
                <button title="Collection"
                    className="btn btn-sm btn-success mx-1"
                    onClick={e => {
                        setPromisedToCollectionSingle(row)
                        setPromisedToCollectionModelShow(true)

                    }
                    }>
                    Collection
                </button>
                {/* edit */}
                <button title="EDIT"
                    className="btn btn-sm btn-warning mx-1"
                    onClick={e => {
                        setPromisedToCollectionSingle(row)
                        setPromiseEditModal(true)
                    }
                    }>
                    Edit
                </button>
                {/* delete */}
                <button title="Delete"
                    className="btn btn-sm btn-danger mx-1"
                    onClick={e => {
                        setPromisedToCollectionSingle(row)
                        setPromiseDeleteModal(true)
                    }
                    }>
                    Delete
                </button>
                <button title="Print" ref={btnRef}
                    className="btn btn-sm btn-info mx-1"
                    onClick={e => {
                        // data for update
                        navigate(`/print?promise_token=${row.id}`);

                    }
                    }>
                    Print
                </button>


            </>
        }
    }

    ];


    return (
        <>
            {/* total wallet table */}
            <Table bordered striped>
                <tbody>
                    <tr>
                        <td>Total Promised</td>
                        <td className=" text-end">{NumberSeparator.format(totalWalletAmount)}</td>
                    </tr>
                </tbody>
            </Table>

            {/* wallet history table */}
            <TableTwoBody
                products={filteredPromisedCollectionHistory}
                columns={columns}
                isBorderd={true}
                is_pagination={false}
            />

        </>
    );
}

export default PromisedHistorytable;